import { Injectable } from '@angular/core';

// rxjs
import { BehaviorSubject } from 'rxjs';

// models
import { AppLoader } from '../models/app-loader.interface';

@Injectable({
  providedIn: 'root',
})
export class AppLoaderService {

  private _count = 0;

  public loaderState$: BehaviorSubject <AppLoader> = new BehaviorSubject({show: false, data: '', count: 0, onlyLoader: false, onlyCaptions: false});

  showLoader(bookingRef?, onlyLoader?, onlyCaptions?) {
    this.loaderState$.next({show: true, data:  bookingRef || '', count: this._count++, onlyLoader: onlyLoader, onlyCaptions: onlyCaptions});
  }

  hideLoader() {
    this.loaderState$.next({show: false, data: '', count: this._count++, onlyLoader: false, onlyCaptions: false});
  }
}
